/**
 * Converts a snake_case or underscore_separated string
 * into a human-readable, title-cased label.
 *
 * @example
 * formatKeyToLabel('filing_date') // "Filing Date"
 *
 * @param key - The key to format (e.g., "filing_date", "case_number").
 * @returns The formatted, human-readable label.
 */
export function formatKeyToLabel (key) {
  if (typeof key !== 'string') return ''

  return key
    .replace(/_/g, ' ') // Replace underscores with spaces
    .replace(/\b\w/g, char => char.toUpperCase()) // Capitalize first letter of each word
}

export const isInvalidValue = (v) =>
  v === null ||
    v === undefined ||
    v === '' ||
    (typeof v === 'string' && v.trim().toLowerCase() === 'n/a')
